module.exports = __webpack_public_path__ + "img/vaccine-logo.4f62eff7.jpg";